/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import { listJobPositions } from '../../../../services/hr/hrApi';

// ---------------------------------------------------------------------------
// Seletor de cargo pretendido / da vaga. Reusa o catálogo de cargos existente
// (GET /hr/job-positions → { id, position_name }). Carrega as opções no mount.
// Renderiza só o <select> — o <Field>/<label> ficam com o call site.
// ---------------------------------------------------------------------------

export default function JobPositionSelect({
   id,
   value,
   onChange,
   disabled = false,
   placeholder = 'Selecione…',
   invalid = false,
}) {
   const [positions, setPositions] = useState([]);
   const [isLoading, setIsLoading] = useState(false);

   useEffect(() => {
      let ignore = false;
      setIsLoading(true);
      listJobPositions()
         .then((list) => {
            if (!ignore) setPositions(list);
         })
         .catch(() => {
            if (!ignore) toast.error('Erro ao carregar os cargos.');
         })
         .finally(() => {
            if (!ignore) setIsLoading(false);
         });
      return () => {
         ignore = true;
      };
   }, []);

   return (
      <select
         id={id}
         value={value ?? ''}
         onChange={(e) => onChange(e.target.value)}
         disabled={disabled || isLoading}
         aria-invalid={invalid || undefined}
      >
         <option value="">{isLoading ? 'Carregando…' : placeholder}</option>
         {positions.map((position) => (
            <option key={position.id} value={String(position.id)}>
               {position.position_name}
            </option>
         ))}
      </select>
   );
}

JobPositionSelect.propTypes = {
   id: PropTypes.string,
   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   onChange: PropTypes.func.isRequired,
   disabled: PropTypes.bool,
   placeholder: PropTypes.string,
   invalid: PropTypes.bool,
};
